import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { COLORS, FONTS } from '../theme';
import { ROUTINE } from '../data/siteData';
import { Section, SectionHeading, Reveal, Icon, Wave, float } from './common';

export default function Routine() {
  return (
    <Section id="routine" bg={COLORS.sky} sx={{ pt: { xs: 4, md: 6 } }}>
      <Box sx={{ position: 'absolute', top: 80, right: '6%', width: 90, height: 90, borderRadius: '50%', bgcolor: `${COLORS.yellow}88`, animation: `${float} 6s ease-in-out infinite` }} />
      <Box sx={{ position: 'absolute', bottom: 160, left: '4%', width: 70, height: 70, borderRadius: '22px', bgcolor: `${COLORS.pink}44`, transform: 'rotate(18deg)', animation: `${float} 7s ease-in-out infinite` }} />

      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
        <SectionHeading
          eyebrow="A Day at St Lord's"
          title="Our Happy Daily Routine"
          subtitle="A balanced day of play, learning, food and rest, from 9:00 AM to 2:00 PM."
          color={COLORS.purple}
        />

        <Box>
          {ROUTINE.map((r, i) => {
            const contentCol = { xs: 2, md: i % 2 === 0 ? 1 : 3 };
            return (
              <Box key={r.time} sx={{ display: 'grid', gridTemplateColumns: { xs: '56px 1fr', md: '1fr 80px 1fr' }, columnGap: { xs: 1, md: 2 } }}>
                <Box
                  sx={{
                    gridColumn: { xs: 1, md: 2 },
                    gridRow: 1,
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      bottom: 0,
                      left: '50%',
                      width: 5,
                      ml: '-2.5px',
                      borderRadius: 5,
                      bgcolor: `${r.color}55`,
                      display: i === ROUTINE.length - 1 ? 'none' : 'block',
                    },
                  }}
                >
                  <Reveal direction="zoom" sx={{ position: 'relative', zIndex: 1, height: 'fit-content' }}>
                    <Box sx={{ width: 52, height: 52, borderRadius: '50%', bgcolor: r.color, color: '#fff', border: '5px solid #fff', boxShadow: `0 6px 14px ${r.color}88`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Icon name={r.icon} sx={{ fontSize: 24 }} />
                    </Box>
                  </Reveal>
                </Box>

                <Box sx={{ gridColumn: contentCol, gridRow: 1, pb: { xs: 3, md: 4 } }}>
                  <Reveal direction={i % 2 === 0 ? 'left' : 'right'} delay={80}>
                    <Box
                      sx={{
                        bgcolor: '#fff',
                        borderRadius: '26px',
                        p: 2.5,
                        borderLeft: `8px solid ${r.color}`,
                        boxShadow: '0 10px 24px rgba(27,42,107,.1)',
                        textAlign: 'left',
                        transition: 'transform .3s ease',
                        '&:hover': { transform: 'scale(1.03)' },
                      }}
                    >
                      <Box sx={{ display: 'inline-block', px: 1.8, py: 0.2, mb: 0.8, borderRadius: 50, bgcolor: r.color, color: '#fff', fontFamily: FONTS.heading, fontWeight: 800, fontSize: 15 }}>
                        {r.time}
                      </Box>
                      <Typography variant="h5" sx={{ fontSize: 21, color: COLORS.navy, lineHeight: 1.15 }}>{r.title}</Typography>
                      <Typography sx={{ mt: 0.7, fontSize: 15, lineHeight: 1.6 }}>{r.text}</Typography>
                    </Box>
                  </Reveal>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Container>
      <Wave color="#ffffff" sx={{ mt: 2, mb: '-2px' }} />
    </Section>
  );
}
